const historyRTLStyles = {
  '.unread': {
    right: '46px',
    left: 'auto !important',
  },
  '.messageColumn': {
    marginLeft: '0 !important',
    marginRight: '20px',
  },
  '.messageRow': {
    paddingRight: '0 !important',
    paddingLeft: '16px',
    textAlign: 'right',
  },
};

export default historyRTLStyles;
